export const HTTP_REQUEST = "HTTP_REQUEST";
export const HTTP_SUCCESS = "HTTP_SUCCESS";
export const HTTP_FAILURE = "HTTP_FAILURE";
export const SET_MODO_APP = "SET_MODO_APP";
export const SET_FECHA_SESION = "SET_FECHA_SESION";
export const SET_ESTADO_COMPLETADO = "SET_ESTADO_COMPLETADO";
export const SET_PACIENTE_SESION = "SET_PACIENTE_SESION";
export const SET_USUARIO_SESION = "SET_USUARIO_SESION";
